import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { ButtonWithTooltip } from '@sales-center/components'
import { ConvertButtonProps } from './typings'
import { useActions } from './useActions'

const getStyles = (theme: Theme) => ({
  tooltip: {
    display: 'flex',
    alignItems: 'center',
  },

  button: {
    marginRight: theme.spacing(1),
  },
})

export const ConvertToOpportunityButton: React.FC<ConvertButtonProps> = (
  props,
) => {
  const {
    lead: { id },
  } = props

  const { buttonTooltip, buttonDisabled, openConvertForm } = useActions(props)
  const styles = getStyles(useTheme())
  return (
    <>
      <ButtonWithTooltip
        spanSx={styles.tooltip}
        sx={styles.button}
        variant="contained"
        disableElevation
        color="primary"
        onClick={openConvertForm}
        disabled={buttonDisabled}
        showTooltip={Boolean(buttonTooltip)}
        tooltipTitle={buttonTooltip}
        data-test-id={`convertBtn-${id}`}
      >
        Convert to Opportunity
      </ButtonWithTooltip>
    </>
  )
}
ConvertToOpportunityButton.displayName = 'ConvertToOpportunityButton'
